// Last successful sign-in (ADR-015). Cookie is set by the API (not HttpOnly).
export const LOGIN_HINT_COOKIE = "rrid_login_hint";

export function readLoginHint(): { email: string; method: "google" | "email-link" } | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|;\s*)rrid_login_hint=([^;]*)/);
  if (!match?.[1]) return null;
  const raw = decodeURIComponent(match[1]);
  const [email, method] = raw.split("|");
  if (!email || (method !== "google" && method !== "email-link")) return null;
  return { email, method };
}

export function googleAuthorizeHref(email: string): string {
  const params = new URLSearchParams({ login_hint: email.trim().toLowerCase() });
  return `/api/auth/google?${params.toString()}`;
}
